import React from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { Notice } from '@vimeo/iris/components';

const ThreeSixtyNotice = () => {
  const text = translate({
    singular: 'You need a 360 player to watch this download. {A}See our recommendations{/A}.',

    replacements: {
      A: (children: React.ReactNode) => (
        <a href="https://www.vimeo.com/help/sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/115001878167#downloading">
          {children}
        </a>
      ),
    },
  });

  return (
    <Notice format="primary">
      <span className="iris_notification-text">{text}</span>
    </Notice>
  );
};

export default ThreeSixtyNotice;
